module.exports = __webpack_public_path__ + "static/media/restaurants (3).ffb73ec0.jpg";